import React from 'react';
import { Box, Container, Typography, styled, Button, Stack } from '@mui/material';
import { motion } from 'framer-motion';
// Link import kiya gaya hai routing ke liye
import { Link as RouterLink } from 'react-router-dom'; 
import SendIcon from '@mui/icons-material/Send';
import BoltIcon from '@mui/icons-material/Bolt';

const PromoSection = styled(Box)({
    padding: '120px 0',
    background: '#030712', 
    position: 'relative',
    overflow: 'hidden',
});

const GlowCard = styled(motion.div)({
    padding: '80px 40px',
    background: 'rgba(255, 255, 255, 0.01)',
    borderRadius: '40px',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(20px)',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
    overflow: 'hidden',
    '&::after': {
        content: '""',
        position: 'absolute',
        top: '-50%',
        left: '-50%',
        width: '200%',
        height: '200%',
        background: 'radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, transparent 50%)',
        zIndex: -1,
    }
});

const MainCTAButton = styled(Button)({
    background: 'linear-gradient(90deg, #2dd4bf, #3b82f6)',
    color: '#fff',
    padding: '16px 40px',
    borderRadius: '16px',
    fontWeight: 800,
    fontSize: '1.1rem',
    textTransform: 'none',
    boxShadow: '0 10px 30px rgba(45, 212, 191, 0.3)',
    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    '&:hover': {
        transform: 'scale(1.05) translateY(-5px)',
        boxShadow: '0 20px 40px rgba(45, 212, 191, 0.5)',
        background: 'linear-gradient(90deg, #2dd4bf, #3b82f6)',
    }
});

const CTASection = () => {
    return (
        <PromoSection>
            {/* Background Decorations */}
            <Box sx={{ 
                position: 'absolute', top: '20%', left: '-10%', width: '400px', height: '400px', 
                background: 'rgba(45, 212, 191, 0.08)', filter: 'blur(100px)', borderRadius: '50%' 
            }} />
            <Box sx={{ 
                position: 'absolute', bottom: '10%', right: '-10%', width: '500px', height: '500px', 
                background: 'rgba(139, 92, 246, 0.08)', filter: 'blur(120px)', borderRadius: '50%' 
            }} />

            <Container maxWidth="md">
                <GlowCard
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <Stack direction="row" justifyContent="center" spacing={1} sx={{ mb: 2 }}>
                        <BoltIcon sx={{ color: '#2dd4bf', fontSize: '1.5rem' }} />
                        <Typography variant="overline" sx={{ color: '#2dd4bf', fontWeight: 900, letterSpacing: 4 }}>
                            HIRE THE EXPERTISE
                        </Typography>
                    </Stack>

                    <Typography variant="h2" sx={{ 
                        fontWeight: 900, 
                        color: '#fff', 
                        mb: 3, 
                        fontSize: { xs: '2.2rem', md: '3.5rem' },
                        lineHeight: 1.1,
                        letterSpacing: '-0.02em'
                    }}>
                        Have a Project in Mind? <br />
                        <span style={{ 
                            background: 'linear-gradient(90deg, #fff, #94a3b8)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>Let's Build It Together.</span>
                    </Typography>

                    <Typography variant="body1" sx={{ color: '#94a3b8', mb: 6, fontSize: '1.1rem', lineHeight: 1.8 }}>
                        I am currently available for new projects and collaborations. 
                        Whether it's a complex Android hardware integration or a high-speed web ecosystem, 
                        I bring technical excellence to the table.
                    </Typography>

                    <Stack 
                        direction={{ xs: 'column', sm: 'row' }} 
                        spacing={4} 
                        justifyContent="center"
                        alignItems="center"
                    >
                        {/* 1. Route to Contact Page */}
                        <MainCTAButton 
                            component={RouterLink} 
                            to="/contact" 
                            startIcon={<SendIcon />}
                        >
                            Hire Me Now
                        </MainCTAButton>
                        
                        {/* 2. Route to Portfolio Page */}
                        <Typography 
                            component={RouterLink} 
                            to="/portfolio"
                            variant="button" 
                            sx={{ 
                                color: '#fff', 
                                textDecoration: 'none', // Link underline hatane ke liye
                                cursor: 'pointer', 
                                fontWeight: 700,
                                fontSize: '1rem',
                                borderBottom: '2px solid #3b82f6',
                                pb: 0.5,
                                transition: '0.3s',
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': { color: '#3b82f6', borderColor: '#fff', transform: 'translateX(5px)' }
                            }}
                        >
                            Explore My Works
                        </Typography>
                    </Stack>
                </GlowCard>
            </Container>
        </PromoSection>
    );
};

export default CTASection;
